// -- Imports -- //
require('onbrandutilityfunctions/build/conditional-babel-polyfill.bundle.js'); // use all the things!
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); //Development options
const onbrandScss = require('./onbrand.scss'); //Onbrand styles
// const clientScss = require('./client/client.scss'); //client styles //not being used with client-hosted js/css
const htmlHeader = require('./includes/new-header.html');
const htmlFooter = require('./includes/new-footer.html');
const htmlHeadSection = require('./includes/head-section.html');

import mobileMenuHandler from './scriptPartials/mobileMenuHandler';
import shareToggle from './scriptPartials/shareToggle';
import mobileHubNav from './scriptPartials/mobileHubNav';
import frontEndTagging from './scriptPartials/frontEndTagging';
import fullwidthCTAHandler from './scriptPartials/fullwidthCTAHandler';
// import twoColumnsLayout from './scriptPartials/twoColumnsLayout';
import authorBox from './scriptPartials/authorBox';
import streamBanner from './scriptPartials/streamBanner';
import footerDropdownsHandler from './scriptPartials/footerDropdownsHandler';
const { handleFlipbook } = require('./scriptPartials/handleFlipbook');
const { addSideNav } = require('./scriptPartials/leftSideNav');
const moveRecoPanel = require('./scriptPartials/moveRecoPanel');

module.exports = {
  initOnbrand: function initOnbrand(translations, production) {
    // -- Startup -- //
    production ? null : onbrandUtilityFunctions.devMode(devOptions);
    $('body').prepend(htmlHeader);
    $('body').append(htmlFooter);
    $('head').prepend(htmlHeadSection);

    window.onbrandLoaded = false;

    // old time embed error throw "fix" (TODO: make this better)
    onbrandUtilityFunctions.legacyEmbedTileFix();
    // Remove the "touch" class on touchscreen laptops
    onbrandUtilityFunctions.removeTouchForLaptops();
    // Remove the hub function updateOverlaySize
    onbrandUtilityFunctions.overrideHubFuctions();
    // Adds body classes for content type (blogPost, youtube, sales-stream etc)
    onbrandUtilityFunctions.helpfulClasses();
    // Rebuild the share widget for the top-nav
    onbrandUtilityFunctions.fixShareWidgetImproved();
    // warns you if your query string is missing.
    onbrandUtilityFunctions.noQueryStringSafeguard();
    // makes the reco engine sticky to the target / top of screen
    onbrandUtilityFunctions.recoEnginePositioning('.top-nav');

    function ufPersonalizerCallback() {
      frontEndTagging();
    }
    // workaround for the personalizer app
    // after the finishes running, it will look for window.ufPersonalizerCallback and if it exists, will run that function
    window.ufPersonalizerCallback = ufPersonalizerCallback;

    // -- Hub Events -- //
    Hubs.Events.on('load', () => {
      if (!window.onbrandLoaded) {
        // Add your onloads here...
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
        // end your onloads before here...
        window.onbrandLoaded = true;
        frontEndTagging();
        mobileMenuHandler();
        shareToggle();
        mobileHubNav();
        fullwidthCTAHandler();
        // twoColumnsLayout();
        authorBox();
        handleFlipbook();
        streamBanner();
        footerDropdownsHandler();
        if (!document.body.classList.contains('sales-stream')) {
          addSideNav();
        }
      }
    })
      .on('itemsLoaded', (itemIds, selectors) => {
        frontEndTagging();
      }) //eslint-disable-line no-unused-vars
      .on('resize', () => {
        // adjust side cta or addThis by passing a number into the function
        // eg onbrandUtilityFunctions.sideCtaFix(150); will push the side cta down by 150px, do the same for on scroll
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
        fullwidthCTAHandler();
      })
      .on('scroll', () => {
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
      })
      .on('ctaActivate', (ctaId) => {}) //eslint-disable-line no-unused-vars
      .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {}) //eslint-disable-line no-unused-vars
      .on('recoItemsLoaded', () => {
        setTimeout(moveRecoPanel(), 500);
      });

    // The new hub events can trigger before cihost scripts are loaded.
    // This will ensure your scripts fire no matter what, but not more than once for 'load'.
    if (!window.onbrandLoaded) {
      Hubs.Events.trigger('load');
    }
  },
};



// WEBPACK FOOTER //
// ./onbrand.js